/** CheckLine EmployeeRole.SysAdmin. */
export const SYS_ADMIN_ROLE_ID = 1;

/** hr.Employee.Code or login username values that see the Management tab (plus SysAdmin role). */
const MANAGEMENT_EMPLOYEE_CODES = new Set(['lkh', 'lsc', 'dmi', 'twh', 'admin', 'owh']);

export function isAdminEmployeeCode(code?: string | null): boolean {
  return MANAGEMENT_EMPLOYEE_CODES.has((code ?? '').trim().toLowerCase());
}

/**
 * Management tab: SysAdmin role, or employee code / login username LKH, LSC, DMI, TWH, Admin, or OWH.
 * Doctor role is allowed when the code/username matches — it is not SysAdmin-only.
 */
export function isManagementAdmin(
  code?: string | null,
  roleId?: number | null,
  username?: string | null,
): boolean {
  return roleId === SYS_ADMIN_ROLE_ID || isAdminEmployeeCode(code) || isAdminEmployeeCode(username);
}
